import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ColumnSelection } from '../types/selection';
import { DynamicDialogRef } from '../../dynamicdialog';
import { GridMode } from '../types/gridmode';

@Injectable({ providedIn: 'root' })
export class CxTableService {
  gridMode = GridMode.Grid;
  showViewNameModal = false;
  showEditColumnModal = false; 
  showAddEvaluationSidebar = false;
  showViewEvaluationSidebar = false;
  showTranscriptSidebar = false;
  showViewSubmittedEvaluationSidebar = false;
  showExportModal = false;
  showRowActions = false;
  showSelectAllActions = false;
  showSelectMoreThenOneActions = false;

  public filterColumns: any[] = [];
  public columns: any[] = [];
  public settingColumns: any[] = [];
  public $sort = new Subject<any>();
  public $selection: Subject<ColumnSelection> = new Subject<ColumnSelection>();
  public editColumn: any = { column: null, row: null };
  public editColumnRef: DynamicDialogRef | undefined;

  public $random = new Subject();
  public $calcWidth = new Subject();

  random = 0;

  constructor() {}

  setRandom() {
    const val = Math.random() * 10000;

    this.random = val;

    setTimeout(() => {
      this.$random.next(val);
    }, 0);
  }
}
